import React, { useEffect, useState } from 'react'
import Navbar from 'components/navbar'
import CardArticle from 'components/cards/cardArticle'
import { COMMON } from 'utils/intl/common.js'
import LinkAnimate from 'utils/hooks/linkAnimate'

const TAG_ALL = 'All'

function SectionArticles(props) {
  const { data, hideTitle, hideLink, isLimited } = props

  const [currentData, setCurrentData] = useState(data)
  const [indexData, setIndexData] = useState(0)
  const [categories, setCategories] = useState([TAG_ALL])

  const currentCategory = categories[indexData]

  useEffect(() => {
    const getAllCategories = () => {
      for (let i = 0; i < data.length; i++) {
        const tags = data[i].data.tags
        for (let i = 0; i < tags.length; i++) {
          const cat = tags[i]
          setCategories((state) => [...new Set([...state, cat.block])])
        }
      }
    }
    getAllCategories()

    const getDataByCategory = () => {
      let dataByTag = []

      // Get data by tag
      for (let i = 0; i < data.length; i++) {
        const currentData = data[i]
        const tags = currentData.data.tags
        for (let i = 0; i < tags.length; i++) {
          const tag = tags[i]

          if (tag.block === currentCategory) {
            dataByTag.push(currentData)
          }
        }
      }

      if (currentCategory !== TAG_ALL) {
        setCurrentData(dataByTag)
      } else {
        setCurrentData(data)
      }
    }
    getDataByCategory()
  }, [data, currentCategory])

  useEffect(() => {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const name = urlParams.get('name')

    if (name) {
      setTimeout(() => {
        const navbarLinks = document.querySelectorAll('.navbar li')
        for (let i = 0; i < navbarLinks.length; i++) {
          const link = navbarLinks[i].querySelector('span')
          const dataName = link.getAttribute('data-name')
          if (name === dataName) link.click()
        }
      }, 1000)
    }
  }, [])

  return (
    <section className="section-blog mb-6 mb-md-10">
      <div className={`section-blog__head ${hideTitle ? 'section-blog__head--hide-title' : ''} mt-5 mb-1`}>
        {!hideTitle && (
          <span className="f ft-up ft-tertiary ft-600 c-text-black-lightest">{COMMON.ALL_BLOG_ARTICLES}</span>
        )}
        <div>
          <Navbar
            className={`navbar--primary ${hideTitle ? 'navbar--page' : ''}`}
            data={categories}
            indexData={indexData}
            callback={setIndexData}
          />
        </div>
      </div>
      <div className="section-blog__cards">
        {!isLimited &&
          currentData.map((article, index) => <CardArticle key={index} slug={article.uid} data={article.data} />)}
        {isLimited &&
          currentData
            .slice(0, 9)
            .map((article, index) => <CardArticle key={index} slug={article.uid} data={article.data} />)}
      </div>
      {!hideLink && (
        <div className="f f-jc-center">
          <LinkAnimate className="btn btn--secondary mt-4" to="blog/categories">
            {COMMON.SEE_ALL_ARTICLES}
          </LinkAnimate>
        </div>
      )}
    </section>
  )
}

export default SectionArticles
